import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useSession } from "../contexts/SessionContext";
import { ACCESS_DENIED_PATH } from "../utils/accessDenied";

// Nothing behind this gate can render once POST /login has answered 403: there
// is no backend session, so every page would only fire requests that fail. 403s
// from any other endpoint still surface as a toast and leave the page alone.
const LoginForbiddenGate = () => {
  const { loginForbidden } = useSession();

  if (loginForbidden) {
    return <Navigate to={ACCESS_DENIED_PATH} replace />;
  }

  return <Outlet />;
};

export default LoginForbiddenGate;
